<template>
  <div>
    <a-row style="min-height: 500px">
      <a-col :span="11" style="padding-right: 10px">
        <a-row class="iotplt-card-box" style="min-height: 100px">
          <h1>{{ product.module_model_name }}</h1>
          <p>{{ product.module_producer_name }}</p>
        </a-row>

        <a-row class="iotplt-card-box" style="margin-top: 10px">
          <a-descriptions title="模组信息" :column="1" class="iotplt-descriptions">
            <a-descriptions-item label="模组厂商">
              {{ product.module_producer_name }}
            </a-descriptions-item>
            <a-descriptions-item label="模组型号">
              {{ product.module_model_name }}
            </a-descriptions-item>
            <a-descriptions-item label="单价">
              {{ product.unit_price | formatFloat }} 元/片
            </a-descriptions-item>
          </a-descriptions>
        </a-row>
      </a-col>

      <a-col :span="13">
        <a-row class="iotplt-card-box">
          <a-descriptions title="采购信息" :column="1" />
          <a-form class="iotplt-compact-form" :form="form" @submit="handleSubmit">
            <a-form-item label="采购数量" required="required">
              <a-space>
                <a-input-number
                  :min="1"
                  :max="10000000"
                  :step="1"
                  :precision="0"
                  style="width: 120px"
                  @change="handleProductCountChange"
                  v-decorator="['product_count', {
                    rules: [{ required: true, message: '请输入采购数量' }]
                  }]"
                />
                <span>片</span>
              </a-space>
            </a-form-item>

            <a-form-item label="备注">
              <a-textarea
                v-decorator="['remark', {
                  rules: [{ max: 200, message: '最多200个字符' }]
                }]"
                :auto-size="{ minRows: 2, maxRows: 5 }"
              />
            </a-form-item>

            <a-descriptions :column="1" class="iotplt-descriptions iotplt-descriptions-max-6">
              <a-descriptions-item label="费用(元)">
                {{ feeDisplay }}
              </a-descriptions-item>
              <a-descriptions-item label="小计(元)">
                {{ feeDisplay }}
              </a-descriptions-item>
            </a-descriptions>

            <a-form-item>
              <a-space>
                <a-button type="primary" html-type="submit" :loading="submitting">
                  加入购物车
                </a-button>
                <a-button @click="$router.push({ name: 'module_goods' })">返回</a-button>
              </a-space>
            </a-form-item>
          </a-form>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { findModuleGoodsInfo } from '@/api/module_goods'
import { createAgentPurchaseItem, calculateAgentPurchaseItemFee } from '@/api/agent_purchase_item'
import { formatFloat } from '@/utils/filter'

export default {
  name: 'NewModulePurchaseItem',
  data() {
    this.calculateFee = this.$lodash.debounce(this.calculateFee, 400)
    return {
      form: this.$form.createForm(this, { name: 'new_module_purchase_item' }),
      product: {},
      goodsId: 0,
      submitting: false,
      feeDisplay: '',
      totalFee: undefined
    }
  },
  created() {
    this.goodsId = parseInt(this.$route.query.goods_id, 10) || 0
    this.fetchGoodsInfo()
  },
  methods: {
    fetchGoodsInfo() {
      findModuleGoodsInfo(this.goodsId, {
        agent_id: this.$store.getters.userAgentId
      }).then((res) => {
        if (res.code === 0) {
          this.product = res.data
        }
      })
    },

    handleProductCountChange(count) {
      this.feeDisplay = ''
      this.totalFee = undefined
      if (count > 0) {
        this.calculateFee()
      }
    },

    calculateFee() {
      this.form.validateFields(['product_count'], { force: true }, (err, values) => {
        if (err) return
        calculateAgentPurchaseItemFee({
          agent_id: this.$store.getters.userAgentId,
          product_type_slug: 'comm_module',
          goods_id: this.goodsId,
          product_count: values.product_count
        }).then((res) => {
          if (res.code === 0) {
            this.totalFee = res.data.total_fee
            this.feeDisplay = `${formatFloat(res.data.distributor_price)} * ${res.data.product_count} = ${formatFloat(res.data.total_fee)}`
          }
        })
      })
    },

    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (err) return
        this.submitting = true
        createAgentPurchaseItem(Object.assign(
          {
            agent_id: this.$store.getters.userAgentId,
            goods_id: this.goodsId,
            product_type_slug: 'comm_module'
          },
          values
        )).then((res) => {
          this.submitting = false
          if (res.code === 0) {
            this.$router.push({ name: 'cart' })
          }
        }).catch(() => {
          this.submitting = false
        })
      })
    }
  }
}
</script>
